import React, { useRef } from 'react';
import { useSelector } from 'react-redux';
import Select from '@Components/DomElements/Select';
import SelectOption from '@Components/DomElements/SelectOption';
import ProjectsApi from '@Data/projects/Api';
import { ViewProjectSortField } from '@Data/projects/Interfaces';
import { selectedSortByFieldState } from '@Data/projects/Reducer';

const SelectProjectSortField = (props) => {
    const selectRef = useRef();

    const selectedSortField: ViewProjectSortField = useSelector(
        selectedSortByFieldState
    );

    const handleChange = (field: ViewProjectSortField) => {
        ProjectsApi.setSortByField(field);
    };

    const getSortFieldValue = (field: ViewProjectSortField): string => {
        switch (field) {
            case ViewProjectSortField.NAME:
                return 'Sort by Name';
            case ViewProjectSortField.CREATED:
                return 'Sort by Created';
            case ViewProjectSortField.LAST_MODIFIED:
                return 'Sort by Last Modified';
            default:
                return '';
        }
    };

    return (
        <Select
            id="project-sort-field-selector"
            value={getSortFieldValue(selectedSortField)}
            ref={selectRef}
        >
            <SelectOption
                text={getSortFieldValue(ViewProjectSortField.NAME)}
                parentRef={selectRef}
                onClick={() => handleChange(ViewProjectSortField.NAME)}
            />
            <SelectOption
                text={getSortFieldValue(ViewProjectSortField.CREATED)}
                parentRef={selectRef}
                onClick={() => handleChange(ViewProjectSortField.CREATED)}
            />
            <SelectOption
                text={getSortFieldValue(ViewProjectSortField.LAST_MODIFIED)}
                parentRef={selectRef}
                onClick={() => handleChange(ViewProjectSortField.LAST_MODIFIED)}
            />
        </Select>
    );
};

export default SelectProjectSortField;
